
import * as PropTypes from 'prop-types';

import { Avatar } from "@progress/kendo-react-layout";
import { useLocalization } from '@progress/kendo-react-intl';
import { useEffect, useState } from 'react';
import { userIcon } from '@progress/kendo-svg-icons';
import { SvgIcon } from "@progress/kendo-react-common";
import { Link } from 'react-router-dom';

export const Header = (props:any) => {
    const { onButtonClick } = props;
    const localizationService = useLocalization();

    const [user, setUser] = useState('');

    useEffect(() => {
        const loggedInUser = localStorage.getItem("user");
        const username = localStorage.getItem("username");
        if (loggedInUser) {
          setUser(loggedInUser);
        }
        if (username) {
          setUser(username);
        }
      }, []);

    return (
        <header className="header">
            <div className="nav-container">
                <div className="menu-button">
                    <span className={'k-icon k-i-menu'} onClick={onButtonClick} />
                </div>

                <div className="title">
                    <Link to="/home/dashboard">
                        <h1 className={'h1'} >{localizationService.toLanguageString('title','NOT FOUND')}</h1>
                    </Link>
                </div>      

                <Avatar rounded="full" type={'image'} style={{background:'none', textAlign: 'center', alignContent: 'center'}} >
                    <SvgIcon icon={userIcon} style={{verticalAlign: 'baseline'}} />
                </Avatar>
                
                <p style={{margin: '0px 30px 0px 0px'}} >{user}</p>
            </div>
        </header>
    );
}

Header.displayName = 'Header';
Header.propTypes = {
    page: PropTypes.string,
    onButtonClick: PropTypes.func,
    changeTheme: PropTypes.func,
    theme: PropTypes.string,
};
